import { render, staticRenderFns } from "./SolicitacoesTabela.vue?vue&type=template&id=52925047"
import script from "./SolicitacoesTabela.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTabela.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesTabela.vue?vue&type=style&index=0&id=52925047&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports